import {useMemo, useState} from 'react'

import type {ShowSuggestionsEvent, TriggerAndSuggestions} from '../types'

// The triggerAndSuggestions array must be memoized by the caller
export const useAutocompleteTriggersAndSuggestions = (triggerAndSuggestions: TriggerAndSuggestions[]) => {
  const [suggestionEvent, setSuggestionEvent] = useState<ShowSuggestionsEvent | null>(null)

  const triggers = useMemo(() => triggerAndSuggestions.map(({trigger}) => trigger), [triggerAndSuggestions])

  // eslint-disable-next-line react-hooks/preserve-manual-memoization
  const suggestions = useMemo(() => {
    if (!suggestionEvent) return null

    for (const {trigger, suggestionsCalculator} of triggerAndSuggestions) {
      if (suggestionEvent.trigger.triggerChar === trigger.triggerChar) {
        return suggestionsCalculator(suggestionEvent.query)
      }
    }

    return null
  }, [suggestionEvent, triggerAndSuggestions])

  const active = !!suggestionEvent

  return {triggers, suggestions, setSuggestionEvent, active}
}
